import '../../scripts/lib/vue-event-bus.esm';

export default {
  template:
    '<div :class="{\'bewerten-reddot--visible\':this.active, \'bewerten-reddot\':!this.active}">'
    + '<svg data-test-bewerten-reddot xmlns="http://www.w3.org/2000/svg">'
    + '  <circle cx="3" cy="3" r="3" fill="currentColor"/>'
    + '</svg>'
    + '<slot></slot>'
    + '</div>',

  data() {
    return {
      active: false,
    };
  },

  props: {
    reddotkey: {
      type: String,
      required: true,
    },
  },

  mounted() {
    const prefixedReddotKey = `ents:${this.reddotkey}`;
    if (!window.localStorage.getItem(prefixedReddotKey)) {
      window.localStorage.setItem(prefixedReddotKey, true);
    }
    this.active = window.localStorage.getItem(prefixedReddotKey) === 'true';
    this.$bus.$on('reddot:read', (key) => {
      if (key === this.reddotkey) {
        window.localStorage.setItem(prefixedReddotKey, false);
        this.active = false;
      }
    });
  },
};
